import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(private httpClient:HttpClient) {
    this.teamSubject=new Subject();
    this.commercialSubject=new Subject();
    this.programSubject=new Subject();
    this.permissionSubject=new Subject();
    this.allProgramSubject =new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      this.token = localStorage.getItem("token")
    else this.token = sessionStorage.getItem("token")
   }
   token:any;
   //TEAM variables
    pathApiTeam:string="/v1/team";
    teamSubject:Subject<any>;
    userRequest:any;
    urlRequestTeam: string =urlServer.concat(this.pathApiTeam);
   //PROGRAM variables
    pathApiProgram:string="/v1/visits/planning";
    programSubject:Subject<any>;
    programRequest:any;
    urlRequestProgram: string =urlServer.concat(this.pathApiProgram);

    //COMMERCIAL variables
    pathApiCommercial:string="/v1/commercial/";
    commercialSubject:Subject<any>;
    commercialRequest:any;
    urlRequestCommercial: string =urlServer.concat(this.pathApiCommercial);

    //COMMERCIAL variables
    pathApiPermission:string="/v1/user/permission/";
    permissionSubject:Subject<any>;
    permissionRequest:any;
    urlRequestPermission: string =urlServer.concat(this.pathApiPermission);

    //PROGRAM variables
    pathApiAllProgram:string="/v1/visits/programs";
    allProgramSubject:Subject<any>;
    urlRequestProgramWeek: string =urlServer.concat(this.pathApiAllProgram);
    
    urlRequestCommercials:  string =urlServer.concat("/v1/commercials");


    getTeam(filter?: string) {
      let headers: HttpHeaders = new HttpHeaders().set('authorization', 'Bearer ' + this.token);
      let params: any = {};
      if (filter) {
        params.filter = filter;
      }
      this.httpClient.get(this.urlRequestTeam, { headers: headers, params: params }).subscribe((response: any) => {
        this.teamSubject.next(response);
        this.teamSubject.complete();
      });
    }

  getCommercials(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+ this.token);
    return this.httpClient.get<ServiceResponse>(this.urlRequestCommercials,{headers: header});
  }

  getPrograme(uuid:any){
    this.programSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestProgram+"/"+uuid,{headers: header}).subscribe((response: any) => {
        this.programSubject.next(response);
        this.programSubject.complete();
    },
      error => {
      }
    );
  }
  getCommercial(id:any){
    this.commercialSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
      header = header.set('authorization', "Bearer "+this.token );
      this.httpClient.get(this.urlRequestCommercial+id,{headers: header}).subscribe((response: any) => {
        this.commercialSubject.next(response);
        this.commercialSubject.complete();
   },)
  }
  causeBody:any;
  getPermission(uuid:any,cause:any) {
    var urlRequestPermissions= urlServer.concat(this.pathApiPermission,uuid);
    this.permissionSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.patch(urlRequestPermissions,this.causeBody,{headers: header}).subscribe((response: any) => {
        this.permissionSubject.next(response);
        this.permissionSubject.complete();
      },
      error => {
      }
    );
  }
  getAllProgramsWeek(){
    this.allProgramSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestProgramWeek,{headers: header}).subscribe((response: any) => {
        this.allProgramSubject.next(response);
        this.allProgramSubject.complete();
    },
      error => {
      }
    );
  }
}
